import request from "@/utils/request";

// 字典--学科病种列表
export function getSubjectsAndDiseases(params) {
  return request({
    url: "/dict/list",
    method: "get",
    params
  });
}

// 字典--获取技术职称
export function getUserTitle(params) {
  return request({
    url: "/dict/list",
    method: "get",
    params
  });
}

// 字典--获取学历
export function getUserEducation(params) {
  return request({
    url: "/dict/list",
    method: "get",
    params
  });
}

// 字典--获取学位
export function getUserBachelor(params) {
  return request({
    url: "/dict/list",
    method: "get",
    params
  });
}

// 获取验证码
export function getCode(params) {
  return request({
    url: "/user/getCode",
    method: "get",
    params
  });
}
